"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.document = exports.window = void 0;
const win = window;
exports.window = win;
const doc = document;
exports.document = doc;
//# sourceMappingURL=globals.js.map